import React, { ReactElement } from 'react';

import { SocialElement } from '../atoms';

export default function OAuthComponents(): ReactElement {
  return (
    <div className="mt-4">
      <SocialElement socialType="Google" />
      {/* <SocialElement socialType="Facebook" /> */}
      <SocialElement socialType="Apple" />
    </div>
  );
}